import React from "react";
import { Button } from "react-bootstrap";
import "../../../assets/styles/informationLayer.scss";

const InformationUpdateButons = ({
  onReset,
  onSave,
  isSaving = false,
  isSaveDisabled = false,
}) => {
  return (
    <div className="information-bulk-update-action-bar mt-3">
      <div className="information-bulk-update-action-bar__buttons information-bulk-update-action-bar__buttons--row create-user-form__actions-col">
        <Button
          className="btn create-user-form__btn create-user-form__btn--reset information-bulk-update-action-button"
          onClick={onReset}
        >
          Reset
        </Button>
        <Button
          className="btn create-user-form__btn create-user-form__btn--save information-bulk-update-action-button"
          onClick={onSave}
          disabled={isSaving || isSaveDisabled}
        >
          {isSaving ? "Zapisywanie..." : "Zapisz"}
        </Button>
      </div>
    </div>
  );
};

export default InformationUpdateButons;
